import router from '../main'
const actions = {
  changeWelcomeMsg ({ commit }, newWelcomeMsg) {
    commit('changeWelcomeMsg', newWelcomeMsg)
  },
  logOut ({ commit }) {
    localStorage.clear('authToken')
    commit('refreshLoggedIn')
    router.replace({ path: '/portal/login' })
  },
  logIn ({commit}, credentials) {
    console.log(credentials)
    localStorage.setItem('authToken', 'test')
    commit('setUser', {name: 'Test User', email: 'test@test.com'})
    commit('refreshLoggedIn')
    router.replace({ path: '/portal' })
  }
}
export default actions
